export class StickyHeader {
    constructor(savKey, content, shouldSticky = false) {
        var _a, _b, _c, _d;
        this.savKey = savKey;
        this.content = content;
        this.originalSalesDesignationOffSetTop = 0;
        this.didScroll = false;
        this.consumerCssModification = '';
        this.shouldSticky = shouldSticky;
        this.isPDP = !!document.getElementById('product-details-page-entry');
        this.aasScope = document.querySelector(`.scope-aas[data-sav-key="${savKey}"][data-content="${content}"]`);
        this.aasSalesDesignationHeader = (_a = this.aasScope) === null || _a === void 0 ? void 0 : _a.querySelector('.aas-salesdesignation-header-container');
        this.aasContent = (_b = this.aasScope) === null || _b === void 0 ? void 0 : _b.querySelector('.aas-content');
        const salesDesignation = (_c = this.aasScope) === null || _c === void 0 ? void 0 : _c.querySelector('.aas-grid .index-product .sav-salesdesignation');
        this.originalSalesDesignationOffSetTop = (_d = salesDesignation === null || salesDesignation === void 0 ? void 0 : salesDesignation.offsetTop) !== null && _d !== void 0 ? _d : 0;
        this.bindEvents();
    }
    bindEvents() {
        document.addEventListener('scroll', () => {
            this.didScroll = true;
        }, true);
        this.trackScrollChanges();
        window.shell.subscribeTo('AAS.view.shown', this.rebindScrollContainer.bind(this), 'AAS.view.shown.sticky.header');
        window.shell.subscribeTo('AAS.view.changed', this.saveConsumerViewChange.bind(this), 'AAS.view.changed.sticky.header');
    }
    trackScrollChanges() {
        const update = () => {
            if (this.didScroll && this.shouldSticky) {
                this.didScroll = false;
                this.setHeaderSticky();
            }
            requestAnimationFrame(update);
        };
        requestAnimationFrame(update);
    }
    rebindScrollContainer(payload) {
        var _a, _b;
        if (payload.detail.useStickyHeader != null) {
            this.shouldSticky = payload.detail.useStickyHeader;
            if (this.isPDP) {
                const salesDesignation = (_a = this.aasScope) === null || _a === void 0 ? void 0 : _a.querySelector('.aas-grid .index-product .sav-salesdesignation');
                this.originalSalesDesignationOffSetTop = (_b = salesDesignation === null || salesDesignation === void 0 ? void 0 : salesDesignation.offsetTop) !== null && _b !== void 0 ? _b : 0;
            }
        }
    }
    saveConsumerViewChange(payload) {
        var _a, _b;
        this.consumerCssModification = (_b = (_a = payload.detail.cssModification) === null || _a === void 0 ? void 0 : _a.salesdesignationHeaderViewSticky) !== null && _b !== void 0 ? _b : '';
        this.setConsumerViewChange();
    }
    setConsumerViewChange() {
        if (this.aasSalesDesignationHeader.classList.contains('sticky')) {
            this.aasSalesDesignationHeader.style.cssText = this.consumerCssModification;
        }
        else {
            this.aasSalesDesignationHeader.style.cssText = '';
        }
    }
    setHeaderSticky() {
        const topPosition = this.originalSalesDesignationOffSetTop - this.scrollPosition();
        const shouldStick = topPosition <= 10;
        this.aasSalesDesignationHeader.classList.toggle('sticky', shouldStick);
        this.setConsumerViewChange();
    }
    scrollPosition() {
        var _a, _b;
        return (_b = (_a = this.aasContent) === null || _a === void 0 ? void 0 : _a.scrollTop) !== null && _b !== void 0 ? _b : window.scrollY;
    }
}
